var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53026 5.78026C5.38962 5.92087 5.19889 5.99985 5.00001 5.99985C4.80114 5.99985 4.61041 5.92087 4.46976 5.78026L0.227013 1.53751C0.155381 1.46833 0.0982438 1.38557 0.058937 1.29407C0.0196303 1.20256 -0.00105945 1.10415 -0.00192481 1.00456C-0.00279017 0.90498 0.0161863 0.80622 0.053897 0.714048C0.0916076 0.621876 0.147297 0.538136 0.217717 0.467717C0.288137 0.397297 0.371875 0.341607 0.464047 0.303897C0.55622 0.266186 0.65498 0.24721 0.754564 0.248075C0.854149 0.248941 0.952563 0.26963 1.04407 0.308937C1.13557 0.348244 1.21833 0.40538 1.28751 0.477013L5.00001 4.18951L8.71251 0.477013C8.85397 0.340394 9.04342 0.264799 9.24006 0.266507C9.43671 0.268216 9.62482 0.347093 9.76388 0.486149C9.90293 0.625205 9.98181 0.813314 9.98352 1.00996C9.98523 1.20661 9.90963 1.39606 9.77301 1.53751L5.53026 5.78026Z",
    fill: "#FFFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni11);
export default __webpack_public_path__ + "static/media/Ani11.65ab6057b42399a930f4133853bf0b5f.svg";
export { ForwardRef as ReactComponent };